class Work {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    const points = document.querySelectorAll(".js-point")
    const menuList = document.querySelectorAll(".js-menu-inview");

    // 対象のエレメント
    // optionは省略可能、初期値は以下のようになります。
    const option = {
        root: null,
        rootMargin: "-100px",
        threshold: [0]
    };

    points.forEach((dot,i) => {
      // 交差した際の処理を記載
      const callback = function (entries, observer) {
          entries.forEach(function (entry) {
              // 交差している場合はtrue
              if (entry.isIntersecting) {
                  // 処理実行
                  // 処理完了後、監視を止めたい場合
                  if(menuList[i]){
                    menuList.forEach((menu) => {
                      menu.classList.remove("is-inview")
                    })
                    menuList[i].classList.add("is-inview")
                  }
              }
          });
      };
      const observer = new IntersectionObserver(callback, option); // callback, optionを設定
      // Polyfillを使っている場合コメントアウトを外す
      // observer.POLL_INTERVAL = 100;
      observer.observe(dot); // 監視を開始
    })

    $(function(){
      // #で始まるa要素をクリックした場合に処理（"#"←ダブルクォーテンションで囲むのを忘れずに。忘れるとjQueryのバージョンによっては動かない。。）
      $('a[href^="#"]').click(function(){
        // 移動先を0px調整する。0を30にすると30px下にずらすことができる。
        var adjust = -30;
        // スクロールの速度（ミリ秒）
        var speed = 400;
        // アンカーの値取得 リンク先（href）を取得して、hrefという変数に代入
        var href= $(this).attr("href");
        // 移動先を取得 リンク先(href）のidがある要素を探して、targetに代入
        var target = $(href == "#" || href == "" ? 'html' : href);
        // 移動先を調整 idの要素の位置をoffset()で取得して、positionに代入
        var position = target.offset().top + adjust;
        // スムーススクロール linear（等速） or swing（変速）
        $('body,html').animate({scrollTop:position}, speed, 'swing');
        return false;
      });
    });

    const SwiperAll = document.querySelectorAll(".work-swiper")


    for (let i = 1; i <= SwiperAll.length; i++) {
      const swiper = new Swiper(`.work-swiper-0${i}`, {
        // ページネーションが必要なら追加
        allowTouchMove: false,
        speed: 800,
        loop: true,
        autoplay: {
          delay: 3000 + (i * 300) ,
        },
        pagination: {
          el: `.swiper-pagination-0${i}`
        },

      });
    }



  }
}
